import { Workbook } from "exceljs";
import { saveAs } from 'file-saver';

const COLUMN_WIDTH_PADDING = 2;
const MIN_COLUMN_WIDTH = 10;

function getCellWidth(str?: string): number {
  if (!str) return MIN_COLUMN_WIDTH;

  const newlineIndex = str.indexOf('\n'); // only calculate width on the first line
  return newlineIndex === -1 ? str.length : newlineIndex;
}

export default function useXlsx(): [
  (data: unknown[], fileName: string, firstRowHeader?: boolean) => void
] {
  const exportXlsx = (data: unknown[], fileName: string, firstRowHeader = false) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    worksheet.addRows(data);

    // set cell width
    worksheet.columns.forEach(column => {
      let maxLength = 0;
      column.eachCell?.({ includeEmpty: false }, cell => {
        const cellLength = getCellWidth(cell.value?.toString());
        maxLength = cellLength > maxLength ? cellLength : maxLength;
      });
      column.width = (maxLength < MIN_COLUMN_WIDTH ? MIN_COLUMN_WIDTH : maxLength) + COLUMN_WIDTH_PADDING;
    });

    // set cell style
    worksheet.eachRow({ includeEmpty: true }, row => {
      row.eachCell({ includeEmpty: true }, cell => {
        cell.alignment = {
          wrapText: true,
          vertical: 'top'
        };
      });
    });

    // set header style
    if (firstRowHeader) {
      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true };
      headerRow.alignment = { horizontal: 'center' };
      headerRow.commit();
    }

    workbook.xlsx.writeBuffer()
      .then((buffer) => {
        saveAs(new Blob([buffer]), `${fileName}.xlsx`);
      }).catch((error) => {
        console.error('Error writing file', error);
      });
  };

  return [exportXlsx];
}
